import { AlertTriangle, TrendingUp } from "lucide-react";
import { useTranslation } from "react-i18next";

const RiskManagementMockup = () => {
  const { t } = useTranslation();

  const risks = [
    {
      title: t("riskMockup.risks.supplyChain.title"),
      desc: t("riskMockup.risks.supplyChain.desc"),
      severity: t("riskMockup.severity.high"),
      color: "bg-amber-50 text-amber-600 border-amber-200",
      icon: <AlertTriangle className="w-4 h-4" />,
      border: "border-l-amber-400",
    },
    {
      title: t("riskMockup.risks.budget.title"),
      desc: t("riskMockup.risks.budget.desc"),
      severity: t("riskMockup.severity.medium"),
      color: "bg-blue-50 text-blue-600 border-blue-200",
      icon: <TrendingUp className="w-4 h-4" />,
      border: "border-l-blue-400",
    },
    {
      title: t("riskMockup.risks.weather.title"),
      desc: t("riskMockup.risks.weather.desc"),
      severity: t("riskMockup.severity.low"),
      color: "bg-gray-100 text-gray-500 border-gray-200",
      icon: <div className="w-4 h-4 rounded-full border-2 border-gray-400" />,
      border: "border-l-gray-300",
    },
  ];

  return (
  <div className="bg-white rounded-2xl shadow-xl p-6 w-full max-w-md">
    {/* Header */}
    <div className="flex items-center justify-between mb-5">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 bg-blue-50 rounded-xl flex items-center justify-center">
          <AlertTriangle className="w-5 h-5 text-blue-500" />
        </div>
        <span className="font-bold text-gray-900 text-lg">{t("riskMockup.title")}</span>
      </div>
      <div className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center">
        <span className="text-red-500 font-bold text-sm">3</span>
      </div>
    </div>

    {/* Risk Cards */}
    <div className="space-y-3">
      {risks.map((risk, i) => (
        <div
          key={i}
          className={`bg-gray-50 rounded-xl p-4 border-l-4 ${risk.border}`}
        >
          <div className="flex items-center justify-between mb-2">
            <h4 className="font-semibold text-gray-900">{risk.title}</h4>
            <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold border ${risk.color}`}>
              {risk.icon}
              {risk.severity}
            </span>
          </div>
          <p className="text-sm text-gray-500 leading-relaxed">{risk.desc}</p>
        </div>
      ))}
    </div>
  </div>
  );
};

export default RiskManagementMockup;
